import { Injectable, signal } from '@angular/core';
import { MasterServiceService } from '../service/master-service.service';
import { CMSStorageService } from '../service/CMS-Storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  // Store the current user as a signal
  user = signal<any>(null);

  constructor(
    private masterService: MasterServiceService,
    private storage: CMSStorageService
  ) {}

  /**
   * Fetch user profile after login or token refresh
   */
  loadUserProfile(): void {
    this.masterService.getById().subscribe({
      next: (res) => {
        const data = res?.data;
        if (!data) return;

        // Update signal
        this.user.set(data);

        // Persist user details
        this.storage.setItem('UserId', data.id);
        this.storage.setItem('perjectManagerName', data?.projectManagerDetails?.[0]?.fullName);
        this.storage.setItem('projectManagerId', data?.projectManagerDetails?.[0]?.id);
        this.storage.setItem('reportingManagerId', data?.teamLeadDetails?.id);
        this.storage.setItem('Name', data?.employeePersonalDetailsDTO?.employeeName);
        this.storage.setItem('TeamLeadMailId', data?.teamLeadDetails?.fullName);
        this.storage.setItem('userId', data?.employeeId);
        this.storage.setItem('Id', data.id);
        this.storage.setItem('roleName', data.masterRoleDTOList);
      },
      error: () => {
        console.warn('Failed to load user profile.');
      },
    });
  }

  /**
   * Call on logout
   */
  clearUser() {
    this.user.set(null);
    // this.storage.clearAll(); // Optional if you have this method
  }
}
